<template>
  <div>
  <div id="page" data-swup="0" class="device-is-android">
    <header-bar :title="title"></header-bar>

    <footer-bar></footer-bar>
    <div
      class="page-content header-clear-medium has-footer-menu"
      style="transform: translateX(0px)"
    >
      <!-- <el-carousel :interval="4000" height="300px" arrow="always">
        <el-carousel-item
          v-for="task in featuredTasks"
          :key="`ftrd_${task.id}`"
        >
          <div  @click="handleDetailModal({ show: true, id: task.id })"
            class="card card-style bg-1"
            data-card-height="300"
            :style="`height: 300px;     background-repeat: no-repeat !important; background: url('${task.defaultAttachmentUrl}?w=600&h=450&mode=crop')`"
          >
            <div class="card-bottom">
              <h4 class="color-white px-3 mb-0">{{ task.task }}</h4>
              <p class="px-3 color-white font-15 opacity-60"></p>
            </div>
            <div class="card-overlay bg-gradient"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="divider mb-3"></div> -->
      <div class="card card-style mg-t-20">
        <!-- {{tasks}} -->
        <div class="content">
          <h1>Нийтлэл Бичих</h1>
          <!-- <p>
                        Тэмдэгтийн хязгаартай тул та бичих юмаа сайн бодоорой!!!
                    </p> -->
          <div class="form-sent disabled">
            <div>
              <div class="shadow-l rounded-m gradient-green me-n1 ms-n1 mb-n1">
                <h1 class="color-white text-center pt-4">
                  <i
                    class="fa fa-check-circle fa-3x shadow-s scale-box rounded-circle"
                  ></i>
                </h1>
                <h2 class="color-white bold text-center pt-3">Message Sent</h2>
              </div>
            </div>
          </div>
          <div
            id="validator-name"
            class="disabled bg-red-dark content rounded-sm shadow-xl text-center line-height-xs py-3 text-uppercase font-700"
          >
            Нэрээ бичнэ үү!
          </div>
          <div
            id="validator-mail1"
            class="disabled bg-red-dark content rounded-sm shadow-xl text-center line-height-xs py-3 text-uppercase font-700"
          >
            И-Мэйл хаягаа бичнэ үү!
          </div>
          <div
            id="validator-mail2"
            class="disabled bg-red-dark content rounded-sm shadow-xl text-center line-height-xs py-3 text-uppercase font-700"
          >
            И-Мэйл хаяг буруу байна!
          </div>
          <div
            id="validator-text"
            class="disabled bg-red-dark content rounded-sm shadow-xl text-center line-height-xs py-3 text-uppercase font-700"
          >
            Нийтлэлээ бичнэ үү!
          </div>
          <div class="contact-form">
            <div>
              <form
                action="#"
                method="post"
                class="contactForm"
                id="contactForm"
              >
                <fieldset>
                  <!-- <div class="form-field form-name">
                    <label
                      class="contactNameField color-theme"
                      for="contactNameField"
                      >Нэр:<span>(required)</span></label
                    >
                    <input
                      type="text"
                      name="contactNameField"
                      value=""
                      class="round-small"
                      id="contactNameField"
                    />
                  </div> -->
                  <!-- <div class="form-field form-email">
                    <label
                      class="contactEmailField color-theme"
                      for="contactEmailField"
                      >И-Мэйл хаяг:<span>(required)</span></label
                    >
                    <input
                      type="text"
                      name="contactEmailField"
                      value=""
                      class="round-small"
                      id="contactEmailField"
                    />
                  </div> -->
                  <div class="form-field form-text">
                    <label
                      class="contactMessageTextarea color-theme"
                      for="contactMessageTextarea"
                      >Нийтлэл:<span>(required)</span></label
                    >
                    <textarea
                      v-model="taskModel.task"
                      name="contactMessageTextarea"
                      class="round-small"
                      id="contactMessageTextarea" :maxlength="450"
                    ></textarea>
                  </div>
                  <div class="">
                    <div class="mg-b-10">
                      <Upload
                        class="upload-demo"
                        :action="actionURL"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        :multiple="false"
                        list-type="picture"
                        style="width: 100%"
                      >
                        <Button
                          size="medium"
                          type="primary"
                          style="width: 100%"
                          >Зураг оруулах</Button
                        >
                        <!-- <div slot="tip" class="el-upload__tip">jpg/png files with a size less than 500kb</div> -->
                      </Upload>
                      <!-- <div class="file-data pb-5">
                        <input
                          type="file"
                          id="file-upload"
                          class="upload-file bg-highlight shadow-s rounded-s"
                          accept="image/*"
                        />
                        <p class="upload-file-text color-white">
                          Зураг оруулах
                        </p>
                      </div> -->
                    </div>
                  </div>
                  <div class="form-button">
                    <!-- type="submit" -->
                    <input
                      @click="writePost()"
                      class="btn bg-dark text-uppercase font-900 btn-m btn-full border-0 rounded-sm shadow-xl contactSubmitButton"
                      value="Нийтлэл Оруулах"
                      data-formid="contactForm"
                    />
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
          <div class="form-sent disabled">
            <div>
              <div class="shadow-l rounded-m gradient-green me-n1 ms-n1 mb-n1">
                <h1 class="color-white text-center pt-4">
                  <i
                    class="fa fa-check-circle fa-3x shadow-s scale-box rounded-circle"
                  ></i>
                </h1>
                <h2 class="color-white bold text-center pt-3">
                  Нийтлэл амжилттай бичигдлээ.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-bg">
      <div></div>
    </div>

    <div class="divider divider-margins"></div>
  </div>
</div>
</template>

<script>
//const moment = require("moment");
import moment from "moment";
import { getToken } from "@/libs/util";
import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";

import "element-ui/lib/theme-chalk/index.css";
import { Upload, Button } from "element-ui";

export default {
  components: {
    Upload, Button,
    footerBar,
    headerBar,
  },
  data() {
    return {
      actionURL: "",
      tasks: [],
      featuredTasks: [],
      title: "",
      taskModel: {
        task: "",
      },
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
        // {
        //   name: "food2.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
    };
  },
  created: function () {
    this.moment = moment;
  },
  methods: {
    ...mapActions(["handleDetailModal", "handleLoading"]),
    init() {
      this.actionURL =
        "https://mobcore.gosmart.mn/core/uploader?boxId=0&folderId=-999&objectTypeId=6&objectId=0&mode=0&token=" +
        getToken();
      //alert(this.actionURL)
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "get", url: "Task/GetInherited" },
        params: {
          id: 0,
          projectId: this.$store.state.app.groupDefaultProjects.filter(
            (x) => x.objectTypeId == 28
          )[0].id,
          parentId: 0,
          boxId: 0,
          objectTypeId: 28,
          userId: this.$store.state.user.userId,
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          this.taskModel = res.data.task;
        }
        //55489
      });
    },
    handleRemove(file, fileList) {
      this.taskModel.defaultAttachmentId = null;
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleSuccess(e) {
      //console.log(e)
      this.handleLoading({ isLoading: false });
      //this.toggleBodyClass("removeClass", "dynamic-locker");
      this.uploadStart = false;
      if (e.code == 200) {
        this.taskModel.defaultAttachmentId = e.data.uploadedAttachmentId;

        console.log(e);
      }
    },
    writePost() {
      if(this.taskModel.task==null || this.taskModel.task.length<100){
        alert("100 с дээш тэмдэгт оруулна уу")
      }
      else if(this.taskModel.defaultAttachmentId == null){
        alert("Зураг оруулна уу")
      }
      else{
        this.taskModel.isPublic=true;
//PostInheritedTask();
      this.handleLoading({ isLoading: true });
      request({
        api: { method: "post", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        this.$router.push({
          name: "niitlel",
        });
        if (res.result == 1) {
        }
      });
      }
      
    },
  },
  mounted() {
    if (this.$store.state.user.userId == "") {
      this.$router.push({
        name: "login",
      });
    } else this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
<style>
.el-upload {
  width: 100%;
}
</style>
